<template>
    <b-modal ref="notesModal" :title="readOnly ? 'Ver Notas' : 'Seleccionar Nota'" hide-footer size="md" centered :no-close-on-backdrop="true"
        :no-close-on-esc="true">
        <div v-if="notes && notes.length > 0">
            <div v-if="productName" class="product-name mb-3">
                <h5 class="text-primary">{{ productName }}</h5>
            </div>

            <div v-for="noteGroup in notes" :key="noteGroup.cas_number" class="cas-group mb-4">
                <h6 class="cas-title">
                    CAS: {{ noteGroup.cas_number }}
                </h6>

                <div class="notes-list">
                    <b-form-radio-group v-model="internalSelectedNotes[noteGroup.cas_number]"
                        :name="`notes-${noteGroup.cas_number}`" stacked
                        :disabled="readOnly"
                        :key="`radio-group-${noteGroup.cas_number}-${internalSelectedNotes[noteGroup.cas_number]}`">
                        <b-form-radio v-for="note in noteGroup.notes" :key="note.id" :value="parseInt(note.id)"
                            class="note-option mb-2">
                            <div class="note-content">
                                <div class="note-text">{{ note.note }}</div>
                                <div class="note-threshold">Umbral: {{ note.umbral }}</div>
                            </div>
                        </b-form-radio>
                    </b-form-radio-group>
                </div>
            </div>
        </div>

        <div v-else class="text-center py-4">
            <i class="fas fa-info-circle fa-2x text-muted mb-2"></i>
            <p class="text-muted mb-0">No hay notas disponibles</p>
        </div>

        <div class="modal-actions mt-4 d-flex justify-content-end">
            <b-button variant="secondary" class="mr-2" @click="cancel">
                {{ readOnly ? 'Cerrar' : 'Cancelar' }}
            </b-button>
            <b-button v-if="!readOnly" variant="primary" @click="save" :disabled="!isValid">
                Guardar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "Notes",
    props: {
        notes: {
            type: Array,
            default: () => []
        },
        selectedNotes: {
            type: Array,
            default: () => []
        },
        productName: {
            type: String,
            default: ''
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            internalSelectedNotes: {}
        };
    },
    computed: {
        isValid() {
            return this.notes.length > 0 &&
                this.notes.every(group => {
                    const selected = this.internalSelectedNotes[group.cas_number];
                    return selected !== null && selected !== undefined;
                });
        }
    },
    watch: {
        notes: {
            handler(newNotes) {
                if (newNotes && newNotes.length > 0) {
                    this.initializeSelection();
                }
            },
            immediate: true
        },
        selectedNotes: {
            handler(newSelectedNotes) {
                if (newSelectedNotes && newSelectedNotes.length > 0) {
                    this.initializeSelection();
                }
            },
            immediate: true
        }
    },
    methods: {
        show() {
            this.$refs.notesModal.show();
            this.initializeSelection();
        },

        cancel() {
            this.$refs.notesModal.hide();
            this.$emit('cancel');
        },

        initializeSelection() {
            this.internalSelectedNotes = {};

            if (!this.selectedNotes || this.selectedNotes.length === 0) {
                return;
            }

            this.selectedNotes.forEach(selectedNote => {
                this.$set(this.internalSelectedNotes, selectedNote.cas_number, parseInt(selectedNote.note_id));
            });
        },

        save() {
            const result = Object.entries(this.internalSelectedNotes)
                .filter(([cas, noteId]) => noteId !== null && noteId !== undefined)
                .map(([cas, noteId]) => {
                    const selectedNote = this.notes
                        .find(group => group.cas_number === cas)
                        .notes.find(note => note.id === noteId);

                    return {
                        cas_number: cas,
                        note_id: noteId,
                        umbral: selectedNote.umbral
                    };
                });

            this.$emit('save', result);
            this.$refs.notesModal.hide();
        }
    }
};
</script>

<style scoped>
.product-name {
    text-align: center;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.product-name h5 {
    margin: 0;
    font-weight: 600;
}

.cas-group {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 1rem;
    background: #f8f9fa;
}

.cas-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 0.75rem;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 0.5rem;
}

.notes-list {
    padding-left: 0.5rem;
}

.note-option {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    margin-bottom: 0.5rem;
    transition: all 0.2s;
    background: white;
    cursor: pointer;
    position: relative;
}

.note-option:hover {
    background-color: #e9ecef;
    border-color: #007bff;
}

.note-option>>>.custom-control {
    margin-bottom: 0;
    min-height: auto;
    display: block;
    position: relative;
    padding: 0.75rem;
}

.note-option>>>.custom-control-input {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 1rem;
    height: 1rem;
}

.note-option>>>.custom-control-label {
    cursor: pointer;
    position: relative;
    padding: 0;
    margin-bottom: 0;
    display: block;
    width: 100%;
}

.note-option>>>.custom-control-label::before,
.note-option>>>.custom-control-label::after {
    display: none !important;
}

.note-option>>>.custom-control-input:checked ~ .custom-control-label {
    background-color: #e9ecef;
    border-color: #007bff;
}

.note-option:has(input:checked) {
    background-color: #e9ecef;
    border-color: #007bff;
}

.note-content {
    width: 100%;
}

.note-text {
    font-size: 0.9rem;
    color: #495057;
    line-height: 1.4;
    font-weight: 500;
    margin-bottom: 0.25rem;
}

.note-threshold {
    font-size: 0.8rem;
    color: #6c757d;
    font-weight: 400;
}

.modal-actions {
    border-top: 1px solid #dee2e6;
    padding-top: 1rem;
}
</style>
